export const DEFAULT_INTL = 'en-US'


export const COUNTRIES_QUERY_KEY = 'countries'
export const LANGUAGES_QUERY_KEY = 'languages'

export const OKTA_AUTH_CONFIG_KEY = 'okta-auth-config'
export const OKTA_TOKEN_STORAGE_KEY = 'okta-token-storage'

export const COUNTRY_CODES = {
  EGYPT: 'EG',
  KSA: 'SA',
}
